import { styled } from '@mui/material/styles';

import { Table, Td, Thead, Tr } from '~/common/components/Tables';
import theme from '~/theme/';

type StyledTableProps = React.ComponentProps<typeof Table> & {
  noBorder?: boolean;
};

export const StyledTable = styled(Table)<StyledTableProps>`
  position: relative;
  max-height: 100%;
  overflow: auto;
  margin-top: 1rem;
  border: ${(props) =>
    props.noBorder ? 'none' : `1px solid ${theme?.colors?.gray[200]}`};
`;

export const StyledTHead = styled(Thead)<React.ComponentProps<typeof Thead>>`
  background-color: ${theme?.colors?.blue[50]};
  position: sticky;
  z-index: 5;
  top: 0;
`;

type StyledTdProps = React.ComponentProps<typeof Td> & {
  width?: string;
  backgroundColor?: string;
  textAlign?: string;
  paddingTop?: string;
};

export const StyledTd = styled(Td)<StyledTdProps>`
  border-bottom: 1px solid ${theme?.colors?.gray[200]};
  width: ${(props) => props.width ?? 'auto'};
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  white-space: pre-wrap;
`;

export const StyledTr = styled(Tr)<React.ComponentProps<typeof Tr>>`
  vertical-align: top;
`;
